import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateLocationGeneralDetailsRequest extends BaseUpdateRequest {
    healthAndSafetyAssessment: string;
    lastHealthAndSafetyAssessmentAt: string;
}